<template>
    <!-- there is no any element in this component -->
</template>

<script>

export default{
    props:{
      millisecondsMouseMoveEvent:Number
    },
    data(){
        return{
            youtubePlayer: null,
            fakeEventInterval: null,
        }
    },
    created(){
        this.loadYouTubeAPI();
    },
    beforeDestroy() {
      this.destroyInterval();
    },
    methods:{
      loadYouTubeAPI() {
        if (window.YT && window.YT.Player) {
          this.initializeYouTubePlayer();
        } else {
          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          tag.async = true;
          tag.defer = true;
          document.head.appendChild(tag);
          window.onYouTubeIframeAPIReady = this.initializeYouTubePlayer;
        }
      },
      initializeYouTubePlayer() {
        this.youtubePlayer = new YT.Player("youtubePlayer", {
          events: {
            "onStateChange": this.onPlayerStateChange
          }
        });
      },
      onPlayerStateChange(event) {
        const state = event.data;
        if (state === YT.PlayerState.PLAYING) {
          console.log("[YoutubeWatcher] play");
        } else if (state === YT.PlayerState.PAUSED) {
          console.log("[YoutubeWatcher] stop/pause");
        } else if (state === YT.PlayerState.ENDED) {
          console.log("[YoutubeWatcher] ended");
        }

        this.destroyInterval()
        if (state === YT.PlayerState.PLAYING){                       
          this.fakeEventInterval = setInterval(()=>{
              window.dispatchEvent(new Event("mousemove"));
          }, this.millisecondsMouseMoveEvent);
        }
      },
      destroyInterval(){
        if (this.fakeEventInterval) {
            clearInterval(this.fakeEventInterval);
            this.fakeEventInterval = null;
        }
      }
    }
};
</script>